import React from 'react'
import { graphql } from 'gatsby'

import TextElement from '../text-element/text-element'
import NavigationLinks from './navigation-links'

import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'
import Link from '@/components/link/link'

const NavigationItems = ({ items, handleMainMenu }) =>
  items.map((item, index) => {
    const hasSiblings = items.length > 1
    return (
      <NavigationItem
        item={item}
        key={`navigation-item-${index}`}
        hasSiblings={hasSiblings}
        handleMainMenu={handleMainMenu}
      />
    )
  })

const NavigationItem = ({ item, hasSiblings, handleMainMenu }) => {
  const showDescription = Boolean(
    hasSiblings & (item.navigationLinks.length <= 7)
  )
  const mainUrl = resolvePctLinkUrl(item.mainLink)
  return (
    <div data-cy="navigation-item">
      <TextElement
        type="h3"
        className="pb-lg-4 pt-lg-3"
        data-cy="navigation-item-title"
      >
        {item.externalName}
      </TextElement>
      <NavigationLinks
        items={item.navigationLinks}
        showDescription={showDescription}
        handleMainMenu={handleMainMenu}
      />
      {item.mainLink && (
        <TextElement type="h4" className="pb-lg-4 pt-3">
          <Link to={mainUrl} onClick={() => handleMainMenu && handleMainMenu()}>
            Browse all {item.externalName}
          </Link>
        </TextElement>
      )}
    </div>
  )
}

export default NavigationItems

export const query = graphql`
  fragment PctNavigationItems on DatoCmsPctNavigationItem {
    __typename
    externalName
    id
    codeId
    mainLink {
      ...PctLink
    }
    featuredContent {
      __typename
      ... on DatoCmsPctTopic {
        id
        slug
        externalName
        excerpt: description
        image {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctPage {
        id
        slug
        externalName
        excerpt: headline
        image: imageCard {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctInternalPage {
        id
        slug
        externalName
        excerpt: headline
        image {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctPost {
        id
        slug
        externalName
        excerpt
        image: imageCard {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctPaper {
        id
        slug
        externalName
        excerpt
        image {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctDialog {
        id
        slug
        externalName
        excerpt
        image: imageCard {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctEpisode {
        id
        slug
        externalName
        excerpt
        image: imageCard {
          ...imgPctNavigationItemsFeatured
        }
      }
      ... on DatoCmsPctEvent {
        id
        slug
        externalName
        excerpt
        image: imageCard {
          ...imgPctNavigationItemsFeatured
        }
      }
    }
    navigationItems {
      __typename
      externalName
      mainLink {
        ...PctLink
      }
      navigationLinks {
        ...PctLink
      }
    }
    navigationLinks {
      ...PctLink
    }
  }
`
